import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AdminService } from 'src/app/pages/admin/services/admin.service';

@Component({
  selector: 'app-user-group-modal',
  templateUrl: './user-group-modal.component.html',
  styleUrls: ['./user-group-modal.component.css']
})
export class UserGroupModalComponent implements OnInit {
  employees: any[];
  matchFound: boolean;
  matchFoundCount: number;
  userGroupID: number;
  individualFilter: { [key: string]: any } = {};
  errorMessage: string;
  alertGroupAdded: string;
  userGroups: any[];
  formData: { [key: string]: any } = {};
  employeeSearch = new Subject<any>();

  constructor(private ngbActiveModal: NgbActiveModal, private adminService: AdminService) { }

  ngOnInit(): void {
    this.employees = [];
    this.matchFound = false;
    this.matchFoundCount = 0;
    this.userGroupID = null;
    this.individualFilter = [];
    this.typeSearch();
  }

  searchEmployees() {
    this.getEmployees();
  };

  closeClicked() {
    this.ngbActiveModal.close({ success: false });
  };

  isEmployeeGroup() {
    var fullName;
    this.errorMessage = "";

    if (this.individualFilter != null) {
      this.alertGroupAdded = "";

      this.employees.forEach(val=> {
        if (this.individualFilter.Employee == val.KeyID) {
            fullName = val.FullName;
        }
      });
      this.adminService.getUserGroup().then((response: any) => {
        this.userGroups = response;
        this.userGroups.forEach((val, key) => {
          if (val.UserGroupName == fullName) {
            this.matchFoundCount = this.matchFoundCount + 1;
            if (this.userGroupID == null) {
              this.userGroupID = val.UserGroupID;
            }
          }
        });
      });
    }
  };

  private typeSearch() {
    this.employeeSearch
      .pipe(
        switchMap(employeeSearch => this.adminService.getHRUsers(this.formData.employeeLabel,false,null))
      )
      .subscribe(data => {
        var employees: any = data;
        this.employees = employees;
      });
  }

  getEmployees() {
    if (this.formData.employeeLabel !== null && this.formData.employeeLabel.length >= 2) {
      this.employeeSearch.next();
    }
  }

  addByIndividual() {
    if (this.matchFoundCount === 0) {
      var tempPRCo, tempEmployee;
      this.alertGroupAdded = "";

      this.employees.forEach(val => {
        if (this.individualFilter.Employee === val.KeyID) {
          tempPRCo = val.PRCo;
          tempEmployee = val.Employee;
        }
      });

      this.formData.SqlOver = "";

      this.adminService.userGroupAddSingleUser(-1, this.formData.employeeLabel, true, this.formData.SqlOver, tempPRCo, "Employee", true, tempEmployee).then((response: any) => {
        if (response.success) {
          this.individualFilter.Employee = null;
          this.formData.employeeLabel = null;
          this.ngbActiveModal.close({ UserGroupID: response.ID, success: response.success, closed: false });
        }
      });
    }
    else {
      this.ngbActiveModal.close({ UserGroupID: this.userGroupID, success: true, closed: false });
    }
  };

}
